module.exports = __webpack_public_path__ + "static/media/fvs_valve1_7.0ff71680.jpg";